import { PopperController } from "./popper";

export class PopperContentBinding {
  public role = "@?";
}
export class PopperContentController {
  public popperCtrl: PopperController;
  public role: string;

  constructor() {}

  public closePopper() {
    this.popperCtrl.closePopper();
    this.popperCtrl.$element.find(`.sd-popper-trigger.${this.popperCtrl.popperId}`).focus();
  }
}
export const sdPopperContent: ng.IComponentOptions = {
  controller: PopperContentController,
  require: {
    popperCtrl: "^sdPopper"
  },
  transclude: true,
  template: `<div class="sd-popper-content"
                sd-focus-out="$ctrl.closePopper()" sd-focus-out-condition="$ctrl.popperCtrl.isVisible"
                role="{{$ctrl.role}}"
                ng-keydown="$ctrl.navigatePopper($event)"
                ng-attr-tabindex="{{::$ctrl.popperCtrl.showFocus ? '0' : undefined}}">
                    <ng-transclude></ng-transclude>
                </div>`,
  bindings: <any>new PopperContentBinding()
};
